import { isProductSet } from 'features/product-info';
import { RELATED_SERVICE_ITEM_CLICK } from 'features/related-services';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { createAction } from 'typesafe-actions';
import { selectProductId } from '../selectors';

/**
 * Cобытие должно срабатывать при клике на услугу.
 *
 * @see https://docs.google.com/document/d/1rdaDo_lgIIxoOgSocvCEtCk-kazxZirnyQzQ7uuhfog/edit
 */
export const gaClickService = createAction('GA:clickProduct')<{
  elementType: 'product';
  elementBlock: 'productDetail / services' | 'komplektyDetail / services'; // блок, в котором расположен элемент
  elementName: 'productButtonLink'; // название элемента (productNameLink или productPhotoLink), если кликнули по названию/фото

  productName: string; // название услуги
  productId: string; // id услуги
  productPrice: string; // цена услуги
  productPosition: string; // позиция слева-направо и сверху-вниз от 1
  productBelong: 'LeroyMerlinServices'; // константа, всегда 'LeroyMerlinServices'
  komplektyId: string | null; // идентификатор комплекта (Передавать, если товар-комплект). Для обычных товаров не передавать этот параметр
}>();

/**
 * Cобытие должно срабатывать при клике на услугу (если переход идёт сразу на страницу оформление).
 *
 * @see https://docs.google.com/document/d/1rdaDo_lgIIxoOgSocvCEtCk-kazxZirnyQzQ7uuhfog/edit
 */
export const gaServiceAddToCart = createAction('GA:addToCart')<{
  elementType: 'button';
  elementBlock: 'productDetail / services' | 'komplektyDetail / services'; // блок, в котором расположен элемент

  productQuantity: '1'; // кол-во услуг
  productName: string; // название услуги
  productId: string; // id услуги
  productPrice: string; // цена услуги
  productPosition: string; // позиция слева-направо и сверху-вниз от 1
  productBelong: 'LeroyMerlinServices'; // константа, всегда 'LeroyMerlinServices'
  komplektyId: string | null; // идентификатор комплекта (Передавать, если товар-комплект). Для обычных товаров не передавать этот параметр
}>();

export function* putGaClickService(
  productName: string,
  productId: string,
  productPrice: string,
  productPosition: string,
) {
  const isSet: boolean = yield select(isProductSet);
  const komplektyId: string = yield call(selectProductId);

  yield put(
    gaClickService({
      elementType: 'product',
      elementBlock: isSet ? 'komplektyDetail / services' : 'productDetail / services',
      elementName: 'productButtonLink',
      productName,
      productId,
      productPrice,
      productPosition,
      productBelong: 'LeroyMerlinServices',
      komplektyId: isSet ? komplektyId : null,
    }),
  );
}

export function* putGaServiceAddToCart(
  productName: string,
  productId: string,
  productPrice: string,
  productPosition: string,
) {
  const isSet: boolean = yield select(isProductSet);
  const komplektyId: string = yield call(selectProductId);

  yield put(
    gaServiceAddToCart({
      elementType: 'button',
      elementBlock: isSet ? 'komplektyDetail / services' : 'productDetail / services',
      productQuantity: '1',
      productName: productName,
      productId: productId,
      productPrice: productPrice,
      productPosition: productPosition,
      productBelong: 'LeroyMerlinServices',
      komplektyId: isSet ? komplektyId : null,
    }),
  );
}

export function* runGaClickServiceDetector() {
  yield takeEvery(
    RELATED_SERVICE_ITEM_CLICK,
    function* handle({ payload }: ReturnType<typeof RELATED_SERVICE_ITEM_CLICK>) {
      const positionFromOne = 1;
      const { title, serviceId, price, serviceKey, index } = payload;
      yield putGaClickService(
        title,
        String(serviceId),
        String(price.value),
        String(index === undefined ? '' : index + positionFromOne),
      );
      if (serviceKey === 'measurement') {
        yield putGaServiceAddToCart(
          title,
          String(serviceId),
          String(price.value),
          String(index === undefined ? '' : index + positionFromOne),
        );
      }
    },
  );
}
